module.exports = __webpack_public_path__ + "static/media/hired-banner.8d5cb294.png";